module.exports = __webpack_public_path__ + "static/media/tire-flat.44e28db9.svg";